
import {
    apiRequest,
    LocationCreate,
    LocationUpdate,
    LocationList,
    LocationDetail,
    LocationInactive,
    LocationActive
} from "../../../../../services/adapters/master/locationPresenceService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", LocationList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchInactive = async (query) => {
        return await apiRequest("post", LocationInactive, {
            body: query
        }, true)
    }
    fetchActive = async (query) => {
        return await apiRequest("post", LocationActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository